import DescriptionField from "./DescriptionField/DescriptionField";
import TitleField from "./TitleField/TitleField";
import NullField from "./NullField";
import CustomField from "./Custom";

const Fields = {
  DescriptionField,
  TitleField,
  NullField,
  "custom": CustomField,
};

export default Fields;
